import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

import { lastValueFrom, Subscription } from 'rxjs';

import _ from 'lodash';

import { BankResponseDto, BanksService, LanguageEnum, MemberResponseDto, PaidBankTypeEnumText, PaidByEnumText, PurchasePaidRequestDto, PurchaseResponseDto } from '@api';
import { TranslateService } from '@ngx-translate/core';

import { DefaultModule, PrimeModule } from '@module';
import { InitialNameService, TranslationsPipe } from '@shared';
import { MemberBankDropdownComponent } from '@shared/dropdown/member-bank-dropdown.component';

import { DynamicDropdownComponent, FileImageUploadComponent, LibDropdownModule } from 'pn-core-code';

import { CheckboxModule } from 'primeng/checkbox';
import { ImageModule } from 'primeng/image';
import { KeyFilterModule } from 'primeng/keyfilter';
import { RadioButtonModule } from 'primeng/radiobutton';

@Component({
  selector: 'shared-payment-result-record-form',
  standalone: true,
  imports: [DefaultModule, PrimeModule, TranslationsPipe, KeyFilterModule, RadioButtonModule, MemberBankDropdownComponent, DynamicDropdownComponent, LibDropdownModule, CheckboxModule, FileImageUploadComponent, ImageModule],
  templateUrl: './shared-payment-result-record-form.component.html',
  styleUrl: './shared-payment-result-record-form.component.scss'
})
export class SharedPaymentResultRecordFormComponent implements OnInit, OnChanges {
  @Input() purchaseData: PurchaseResponseDto = {} as PurchaseResponseDto;
  purchasePaidData: PurchasePaidRequestDto = {} as PurchasePaidRequestDto;
  bankData: BankResponseDto = {} as BankResponseDto;
  member: MemberResponseDto = {} as MemberResponseDto;
  paidByType = PurchasePaidRequestDto.PaidByEnum;
  pidByEnumText = PaidByEnumText;
  paidBankTypeEnum = PurchaseResponseDto.PaidBankTypeEnum;
  paidBankTypeEnumText = PaidBankTypeEnumText;

  paidByEnum = PurchaseResponseDto.PaidByEnum;

  fileImage: any;

  bankList: any[] = [];
  currentLang: string;

  translationSub: Subscription;
  constructor(
    private initialNameService: InitialNameService,
    private translateService: TranslateService,
    private banksService: BanksService,
  ) {

    this.translateService.onLangChange.subscribe(t => {
      this.currentLang = t.lang;
      this.getBankDropdown();
    });
  }

  ngOnInit(): void {

    // this.getBankDropdown();

  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes['purchaseData']) {
      await this.getBankDropdown();
      console.log('purchaseData 75', this.purchaseData);
      this.bankData = this.purchaseData.paidToMemberBankId?.bank;
      this.member = this.purchaseData.member;
      this.purchasePaidData.paidBy = this.purchaseData.paidBy;
      this.purchasePaidData.paidBankType = this.purchaseData.paidBankType;
      this.purchasePaidData.paidToMemberBankId = this.purchaseData.paidToMemberBankId?.id;
      this.purchasePaidData.paidToBankId = this.purchaseData.paidToBankId?.id;
      this.purchasePaidData.paidToBankBranchName = this.purchaseData.paidToBankBranchName;
      this.purchasePaidData.paidToBankAccountNo = this.purchaseData.paidToBankAccountNo;
      this.purchasePaidData.rememberBank = this.purchaseData.paidToMemberBankId?.id ? true : false;
      this.purchasePaidData.paidToPromptpay = this.purchaseData.paidToPromptpay;
    }

  }


  async getBankDropdown() {
    this.currentLang = this.translateService.currentLang;
    try {

      const resp = await lastValueFrom(this.banksService.banksDropdownGet$(
        undefined,
        undefined,
        undefined,
        this.currentLang,
        true,
        this.currentLang === LanguageEnum.Th ? 'lang-bank-translations-name-th' : 'lang-bank-translations-name-en'));
      this.bankList = await Promise.all(_.map(resp, async (item) => ({
        id: item.id,
        name: this.initialNameService.initName(item),
        imageUrl: item.iconUrl,
      })));
      console.log('this.bankList ', this.bankList);

    } catch (error) {
      console.log('error ', error);
    }

  }


  onChangePaidByType() {
    console.log('onChangePaidByType')
    if (this.purchasePaidData.paidBy === this.paidByType.Cash) {
      this.purchasePaidData = { paidBy: this.purchasePaidData.paidBy } as PurchasePaidRequestDto;
    } else {
      this.purchasePaidData = { paidBy: this.purchasePaidData.paidBy, paidBankType: this.paidBankTypeEnum.SavedAccount } as PurchasePaidRequestDto;
    }
  }


  onChangePaidBankType() {
    this.purchasePaidData = { paidBy: this.purchasePaidData.paidBy, paidBankType: this.purchasePaidData.paidBankType } as PurchasePaidRequestDto;
  }

}
